import { render } from "./OutsourceHR.vue?vue&type=template&id=49dfb3ac&scoped=true&lang=html"
import script from "./OutsourceHR.vue?vue&type=script&lang=js"
export * from "./OutsourceHR.vue?vue&type=script&lang=js"

import "./OutsourceHR.vue?vue&type=style&index=0&id=49dfb3ac&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-49dfb3ac"

export default script